var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _rect6, _rect7, _rect8, _rect9, _rect0, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLcrGen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 40.8511,
    width: 23.83,
    height: 18.7661,
    rx: 5,
    fill: "#FDC043"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 23.83,
    height: 18.7661,
    rx: 5,
    fill: "#FDC043"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1699,
    y: 40.8511,
    width: 6.25537,
    height: 9.23412,
    fill: "#ED9D0A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.8721,
    y: 20,
    width: 6.25537,
    height: 9.23412,
    fill: "#ED9D0A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.353 57.3887C38.0343 57.5948 37.7552 55.8429 37.9055 54.9412V38.1307L45.7633 31.6899H54.9092C56.1459 31.793 56.5838 32.7205 56.6483 33.1713V55.3921C56.4937 56.7833 55.4245 57.3028 54.9092 57.3887H40.353Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9594 36.7095L45.8684 31.6221L38.3123 37.7483L44.3012 37.6411C45.2323 37.8306 45.7946 37.099 45.9594 36.7095Z",
    fill: "#54B5CC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40.9629,
    y: 40.8359,
    width: 3.86448,
    height: 0.901712,
    rx: 0.450856,
    fill: "#6B7287"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 40.9629,
    y: 45.2158,
    width: 9.14593,
    height: 0.901712,
    rx: 0.450856,
    fill: "#6B7287"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 40.9629,
    y: 47.4058,
    width: 6.82725,
    height: 0.901712,
    rx: 0.450856,
    fill: "#6B7287"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 40.9629,
    y: 49.5952,
    width: 5.92553,
    height: 0.901712,
    rx: 0.450856,
    fill: "#6B7287"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 40.9629,
    y: 43.0259,
    width: 11.9799,
    height: 0.901712,
    rx: 0.450856,
    fill: "#6B7287"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3151 52.692L49.3456 49.9868L51.7287 52.692L49.0236 53.4648C48.3538 53.4133 48.2722 52.9281 48.3151 52.692Z",
    fill: "#F7AA88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0998 43.1597L49.3369 50.0513L51.5912 52.8209L58.9337 45.9292L56.0998 43.1597Z",
    fill: "#54DB72"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8691 45.9291L56.0352 43.243C56.1756 43.1216 56.5409 42.7915 56.878 42.4419C57.2152 42.0924 57.903 42.0002 58.2894 42.3222L59.642 43.6104C60.2861 44.3189 59.9031 44.7118 59.7064 45.0273L58.8691 45.9291Z",
    fill: "#6B7287"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLcrGen);
export default __webpack_public_path__ + "static/media/lcr-gen.42f53af782ef15bcd77c73b8d185536d.svg";
export { ForwardRef as ReactComponent };